import script from "./ProductDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailsView.vue?vue&type=style&index=0&id=2722ffe2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2722ffe2"]])

export default __exports__